import axios from "axios";
import { local } from "./storage";
import auth from "@/api/auth.js";
import { ElMessage } from "element-plus";
import router from "@/router/index.js";
import { ElLoading } from "element-plus";
import qs from "qs";

const instance = axios.create({
  baseURL: window.global_config.BASE_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: "repeat" });
  },
});
let isRefreshing = false; // 是否正在刷新的标记
const requests = []; // 刷新Token时存储的请求
let loading = null;
// request拦截器
instance.interceptors.request.use(
  (config) => {
    const accessToken = local.get("access_token");
    if (accessToken) {
      config.headers["Authorization"] = accessToken;
    }
    if (config.isNeedLoading) {
      loading = ElLoading.service({
        lock: true,
        text: "加载中...",
        background: "rgba(0, 0, 0, 0.5)",
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response拦截器
instance.interceptors.response.use(
  (response) => {
    if (loading) loading.close();
    return response; // 返回数据
  },
  async (error) => {
    if (loading) loading.close();
    if (error.response) {
      switch (error.response.status) {
        case 302:
          break;
        case 400:
          if (!(error.response.config.alertMessage === false)) {
            if (error.response.data.error?.validationErrors?.length > 0) {
              const message = error.response.data.error.validationErrors
                .map((item) => item.message)
                .join(",");
              ElMessage.error(message);
            } else {
              ElMessage.error(error.response.data.error.message);
            }
          }
          break;
        case 401:
          // 刷新token
          return await RefreshFn(error.response);
        case 403:
          if (!(error.response.config.alertMessage === false)) {
            if (error.response.data) {
              ElMessage.error(error.response.data.error.message || "Forbidden");
            } else {
              ElMessage.error("没有此操作的权限！");
            }
          }
          break;
        case 404:
          if (!(error.response.config.alertMessage === false)) {
            ElMessage.error(error.response.data.error.message || "Forbidden");
          }

          break;
        case 500:
          ElMessage.error("服务器错误");
          break;
        default:
          ElMessage.error(error.response.data.error.message || "未知错误");
          break;
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

// 刷新token的函数
async function RefreshFn(response) {
  const access_token = local.get("access_token");
  const refresh_token = local.get("refresh_token");
  if (!access_token || !refresh_token) {
    return Promise.reject(response.data);
  }
  if (!isRefreshing) {
    isRefreshing = true;
    try {
      const res = await auth.refreshToken({ access_token, refresh_token });
      local.set("access_token", res.data.access_token);
      local.set("refresh_token", res.data.refresh_token);
      response.config.headers["Authorization"] = res.data.access_token;
      requests.forEach((cb) => cb(local.get("access_token")));
      requests.length = 0; // 清空请求队列
      return instance.request(response.config);
    } catch (e) {
      ElMessage.error(e.error.message || "Token 刷新失败，请重新登录");
      local.clear()
      if(window.global_config.LoginType === 0){
        router.replace("/login");
      }else{
        router.replace("/AiVideo");
      }
    } finally {
      isRefreshing = false;
    }
  } else {
    // 正在刷新token ,把后来的接口缓冲起来
    requests.push((access_token) => {
      response.config.headers["Authorization"] = access_token;
      instance.request(response.config);
    });
  }
}

export default instance;
